"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var condo_brain_1 = require("condo-brain");
var material_1 = require("@mui/material");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var withStyles_1 = __importDefault(require("@mui/styles/withStyles"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var Table_1 = __importDefault(require("@mui/material/Table"));
var TableBody_1 = __importDefault(require("@mui/material/TableBody"));
var TableCell_1 = __importDefault(require("@mui/material/TableCell"));
var TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
var TableHead_1 = __importDefault(require("@mui/material/TableHead"));
var TableRow_1 = __importDefault(require("@mui/material/TableRow"));
var moment_1 = __importDefault(require("moment"));
var StyledTableCell = (0, withStyles_1.default)(function (theme) { return (0, createStyles_1.default)({
    head: {
        backgroundColor: '#f37f30',
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}); })(TableCell_1.default);
var StyledTableRow = (0, withStyles_1.default)(function (theme) { return (0, createStyles_1.default)({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}); })(TableRow_1.default);
var useStyles = (0, makeStyles_1.default)(function (theme) { return (0, createStyles_1.default)({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '100%',
        },
    },
    table: {
        minWidth: 700,
    },
}); });
function ReservationAdmin() {
    var _this = this;
    var classes = useStyles();
    var _a = (0, react_1.useState)([]), reservations = _a[0], setReservations = _a[1];
    var admin = new condo_brain_1.AdminManager();
    if (!admin) {
        return (react_1.default.createElement("div", null));
    }
    var fetchReservations = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            admin.getReservations().then(function (response) {
                setReservations(response);
            });
            return [2 /*return*/];
        });
    }); };
    (0, react_1.useEffect)(function () {
        fetchReservations();
    }, [reservations.length]);
    return (react_1.default.createElement("div", { className: "section flex-grow" },
        react_1.default.createElement(material_1.Grid, { container: true, spacing: 5 },
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement("h4", { className: "center" }, "Amenity Reservation Admin"),
                react_1.default.createElement(TableContainer_1.default, { component: Paper_1.default },
                    react_1.default.createElement(Table_1.default, { className: classes.table, "aria-label": "customized table" },
                        react_1.default.createElement(TableHead_1.default, null,
                            react_1.default.createElement(TableRow_1.default, null,
                                react_1.default.createElement(StyledTableCell, null, "Amenity"),
                                react_1.default.createElement(StyledTableCell, { align: "right" }, "Resident"),
                                react_1.default.createElement(StyledTableCell, { align: "right" }, "Email"),
                                react_1.default.createElement(StyledTableCell, { align: "right" }, "Starts"),
                                react_1.default.createElement(StyledTableCell, { align: "right" }, "Ends"))),
                        react_1.default.createElement(TableBody_1.default, null, reservations.map(function (row) { return (react_1.default.createElement(StyledTableRow, { key: row.id },
                            react_1.default.createElement(StyledTableCell, { component: "th", scope: "row" }, row.amenity),
                            react_1.default.createElement(StyledTableCell, { align: "right" }, row.userName),
                            react_1.default.createElement(StyledTableCell, { align: "right" }, row.userEmail),
                            react_1.default.createElement(StyledTableCell, { align: "right" }, (0, moment_1.default)(row.startTime).format('llll')),
                            react_1.default.createElement(StyledTableCell, { align: "right" }, (0, moment_1.default)(row.endTime).format('llll')))); }))))))));
}
exports.default = ReservationAdmin;
